<template>
  <Modal
    :open="props.open"
    @close-modal="$emit('close-modal')"
    customHeight="h-auto"
    customWidth="lg:w-120"
  >
    <template #modal-header>
      <div>
        <div
          class="flex items-center"
          :class="modal_config.action == 'request_payout' ? 'text-success' : 'text-error'"
        >
          <Icon name="BadgeDollarSign" class="w-4 h-4 mr-1" />
          <div class="text-sm font-inter font-semibold">Investment action</div>
        </div>
        <div class="font-league tracking-[-.56px] font-semibold text-[1.75rem] text-strongest">
          {{
            modal_config.action == "request_payout"
              ? "Request Return of Funds"
              : "Cancel Return of Funds Request"
          }}
        </div>
      </div>
    </template>

    <template #modal-body>
      <div class="p-6 text-xl font-medium tracking-[-0.4] text-strongest">
        <div>
          {{
            modal_config.action == "request_payout"
              ? "Confirm your return of funds request. You can cancel it anytime before the investment is returned."
              : "Are you sure you want to cancel your return of funds request? You can resubmit the request anytime before the investment is paid out."
          }}
        </div>
        <div
          v-if="modal_config.action == 'request_payout'"
          class="mt-4 text-base font-normal text-strong"
        >
          All matured funds are returned to the original funding account in accordance with company
          policy. If the original funding account is no longer available or accessible, please
          contact our team as soon as possible so we can assist you in arranging an alternative
          disbursement method.
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="flex justify-end gap-2">
        <Button @click="$emit('close-modal')" variant="paper-primary" size="sm" class="">
          <template #label>Cancel</template>
        </Button>
        <Button @click="handleConfirm()" variant="primary-grey" size="sm" class="">
          <template #label>
            {{ modal_config.action == "request_payout" ? "Submit Request" : "Cancel Request" }}
          </template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
//IMPORTS
import { Modal, Icon, Button } from "@/components";
import { useCrudStore, useDataStore, useSchemaStore, useUIStore } from "@/stores";

//STORES
const crudStore = useCrudStore();
const dataStore = useDataStore();
const schemaStore = useSchemaStore();
const UIStore = useUIStore();

//EMITS AND PROPS
const emit = defineEmits(["close-modal", "confirm"]);
const props = defineProps({
  open: { type: Boolean, required: true },
  modal_config: { type: Object, required: true },
});

// COMPONENT LOGIC AND FUNCTIONS
async function handleConfirm() {
  let value = props.modal_config.action == "request_payout" ? true : false;
  let investment_id = props.modal_config.investment_id;

  const query = [
    {
      field_name: "record_id",
      operator: "eq",
      value: investment_id,
    },
  ];
  let update = { user_requested_payout: value };

  update = schemaStore.addCreatedUpdatedFields(update, false, true);

  const res = await crudStore.update("investments", query, update);

  emit("close-modal");

  if (res.status === 200) {
    const inv = dataStore.investments?.find((i) => i.record_id === investment_id);
    if (inv) inv.user_requested_payout = value;

    let message = value
      ? "Return of funds request submitted successfully"
      : "Return of funds request cancelled successfully";

    UIStore.animateNotificationAlert({
      type: "Success",
      icon: "Check",
      message: message,
    });
  } else {
    let message = value
      ? "Failed to submit return of funds request. Please try again."
      : "Failed to cancel return of funds request. Please try again.";

    UIStore.animateNotificationAlert({
      type: "Error",
      icon: "X",
      message: message,
    });
  }
}
</script>
